import { useReactiveMessage } from '@aperza/ui';
import React, { useEffect, useState } from 'react';
// import style from './CatalogVideoModal.module.scss';
import Modal from 'react-bootstrap/Modal';
import ReactDOM from 'react-dom';
const CatalogVideoModal = () => {
    const [open, setOpen] = useState(false);
    const [youTubeUrl, setYouTubeUrl] = useState();
    const [designType, setDesignType] = useState('CatalogPage');
    const { getMessage } = useReactiveMessage('CATALOG_VIDEO');
    const onModalClose = () => {
        setOpen(false);
    };
    let subscription;
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        subscription = getMessage().subscribe((message) => {
            if (message) {
                setYouTubeUrl(message.video.videoUrl);
                setOpen(true);
                if (message.designType) {
                    setDesignType(message.designType);
                }
            }
        });
        const elements = document.getElementsByClassName('modal-youtube');
        if (elements && elements.length > 0) {
            Array.from(elements).forEach((el) => {
                el.addEventListener('click', (event) => {
                    const source = event.currentTarget;
                    if (source && source.dataset.youtube) {
                        event.preventDefault();
                        setYouTubeUrl(source.dataset.youtube);
                        setOpen(true);
                    }
                });
            });
        }
    }, []);
    return (React.createElement(Modal, { show: open, onHide: onModalClose, className: "modal preview-youtube fade", size: "lg", centered: true, role: "video" },
        React.createElement(Modal.Body, { className: "modal-body p-0 position-relative", style: { width: '870px', height: '490px' } },
            React.createElement("button", { className: "position-absolute close", type: "button", "data-dismiss": "modal", "aria-label": "Close", style: { top: 0, right: '-40px' }, onClick: onModalClose },
                React.createElement("span", { className: "text-white", "aria-hidden": "true" },
                    React.createElement("i", { className: "fas fa-times fa-fw" }))),
            React.createElement("div", { className: "embed-responsive h-100" },
                React.createElement("div", { className: "embed-responsive-item" },
                    React.createElement("iframe", { className: "embed-responsive-item", frameBorder: "0", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, src: youTubeUrl }))))));
};
export default CatalogVideoModal;
const renderCatalogVideoModal = () => {
    const modalId = 'aperza-catalog-video-modal';
    const modal = document.getElementById(modalId);
    if (!modal) {
        const aperzaCatalogVideoModal = document.createElement('div');
        aperzaCatalogVideoModal.id = modalId;
        document.body.appendChild(aperzaCatalogVideoModal);
        ReactDOM.render(React.createElement(CatalogVideoModal, null), aperzaCatalogVideoModal);
    }
    else {
        console.warn(`Trying to create additional modal: ${modalId}`);
    }
};
export { renderCatalogVideoModal };
